import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=7b46507e&scoped=true"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContacts.vue?vue&type=style&index=0&id=7b46507e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b46507e",
  null
  
)

export default component.exports